import React from 'react';

interface ITableActionsProps {
  children: React.ReactNode;
}

export const TableActions: React.FC<ITableActionsProps> = ({
  children,
}: ITableActionsProps) => <div className="table-actions">{children}</div>;
